import { create } from 'zustand';
const REFRESH_KEY = 'ssc-refresh-token';
const EMAIL_KEY = 'ssc-email';
export const useSessionStore = create((set, get) => ({
    accessToken: null,
    refreshToken: null,
    usuario: null,
    hidratado: false,
    setSesion: (tokens, usuario) => {
        try {
            localStorage.setItem(REFRESH_KEY, tokens.refreshToken);
            localStorage.setItem(EMAIL_KEY, usuario.email);
        }
        catch {
            /* ignore */
        }
        set({ accessToken: tokens.accessToken, refreshToken: tokens.refreshToken, usuario });
    },
    setAccessToken: (token) => set({ accessToken: token }),
    setRefreshToken: (token) => {
        try {
            localStorage.setItem(REFRESH_KEY, token);
        }
        catch {
            /* ignore */
        }
        set({ refreshToken: token });
    },
    setUsuario: (usuario) => {
        try {
            localStorage.setItem(EMAIL_KEY, usuario.email);
        }
        catch {
            /* ignore */
        }
        set({ usuario });
    },
    limpiar: () => {
        try {
            localStorage.removeItem(REFRESH_KEY);
            localStorage.removeItem(EMAIL_KEY);
        }
        catch {
            /* ignore */
        }
        set({ accessToken: null, refreshToken: null, usuario: null });
    },
    marcarHidratado: () => set({ hidratado: true }),
    tieneRol: (rol) => get().usuario?.roles.includes(rol) ?? false,
    tieneAlgunRol: (roles) => {
        const actuales = get().usuario?.roles ?? [];
        return roles.some((r) => actuales.includes(r));
    },
}));
export function leerRefreshTokenPersistido() {
    try {
        return localStorage.getItem(REFRESH_KEY);
    }
    catch {
        return null;
    }
}
export function leerEmailPersistido() {
    try {
        return localStorage.getItem(EMAIL_KEY);
    }
    catch {
        return null;
    }
}
